import { useEffect, useState } from "react";

import EmailDeliveryContext from "./EmailDeliveryContext";
import { emitter } from "./EmailDeliveryHub";

import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { FC, PropsWithChildren } from "react";

type EmailActivityDto = m.Core.ViewData.EmailActivityDto;

const EmailDeliveryProvider: FC<PropsWithChildren> = ({ children }) => {
	const [emailActivities, setEmailActivities] = useState<EmailActivityDto[]>([]);
	const onMessage = (a: EmailActivityDto) => setEmailActivities(state => [...state, a]);

	useEffect(() => {
		emitter.add(onMessage);
		return () => emitter.remove(onMessage);
	});

	const value = { emailActivities };
	return <EmailDeliveryContext value={value}>{children}</EmailDeliveryContext>;
};

export default EmailDeliveryProvider;
